import React from 'react';
import { neighborhoods } from '../../data/relocation';
import SEO from '../../components/SEO';

const RelocationHousing = () => {
  return (
    <div className="min-h-screen bg-[#F9F6EF]">
      <SEO
        title="Mexico City Neighborhoods"
        description="Best neighborhoods in Mexico City for expats. Polanco, Condesa, Roma Norte, and more - pricing, lifestyle, and insider recommendations."
        path="/relocation/cdmx/housing"
      />
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#F9F6EF] border-b border-[#F4ECD8]">
        <div className="container-wide mx-auto px-8 py-5">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
            </a>
            <nav className="hidden md:flex items-center gap-8">
              <a href="/" className="text-sm font-medium text-[#1A5C6E] hover:text-[#2CA8A0] transition">Home</a>
              <a href="/relocation/cdmx" className="text-sm font-medium text-[#0A1F2E]">Relocation</a>
              <a href="/contact" className="btn-primary text-xs px-6 py-3">Contact</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="section">
        <div className="container-wide mx-auto">
          <a href="/relocation/cdmx" className="inline-block text-sm font-medium text-[#5A6B73] mb-6 hover:text-[#2CA8A0] transition">
            ← Back to Relocation Hub
          </a>
          <p className="label mb-4">Relocation Hub</p>
          <h1 className="heading-xl mb-6">Housing & Neighborhoods</h1>
          <p className="body-lg max-w-3xl">Find your ideal neighborhood and housing in Mexico City.</p>
        </div>
      </section>

      {/* Neighborhoods */}
      <section className="section-sm bg-[#FFFFFF]">
        <div className="container-wide mx-auto">
          <h2 className="heading-lg mb-8 text-center">Neighborhood Guide</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {neighborhoods.map((n) => (
              <div key={n.id} className="bg-[#FFFFFF] border border-[#E0D6B8] p-6">
                <div className="flex justify-between items-start mb-3">
                  <h3 className="heading-sm">{n.name}</h3>
                  <span className="text-sm font-semibold text-[#2CA8A0]">{n.priceRange}</span>
                </div>
                <p className="body-sm mb-3 text-[#1A5C6E]">{n.type}</p>
                <p className="body-md mb-4">{n.description}</p>
                <div className="flex flex-wrap gap-2">
                  {n.bestFor.map((tag, idx) => (
                    <span key={idx} className="text-xs px-2 py-1 bg-[#F4ECD8] text-[#1A5C6E]">{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Housing Tips */}
      <section className="section">
        <div className="container-narrow mx-auto">
          <h2 className="heading-lg mb-8 text-center">Housing Search Tips</h2>
          
          <div className="space-y-6">
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">Rental Market Overview</h3>
              <p className="body-md">Most rentals require 1-2 months deposit plus first month. Furnished apartments are common in expat areas. Typical lease terms are 12 months with 30-day notice for renewal.</p>
            </div>
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">Price Ranges</h3>
              <p className="body-md">Studio/1BR in Roma/Condesa: $800-1,500 USD. 2BR apartments: $1,200-2,500 USD. Polanco/Lomas premium: $2,000-4,000+ USD. Prices include most utilities except electricity.</p>
            </div>
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">What to Look For</h3>
              <p className="body-md">Natural light, building security (24/7 portero), water pressure, noise levels, proximity to metro/services. Ask about water tank capacity and backup systems.</p>
            </div>
            <div>
              <h3 className="heading-sm mb-3">Working with Agents</h3>
              <p className="body-md">Commissions are typically paid by landlord (1 month rent). Use agents familiar with expat needs. We provide vetted agent introductions in Guided and White Glove plans.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-sm bg-[#FFFFFF] border-t border-[#F4ECD8]">
        <div className="container-narrow mx-auto text-center">
          <h2 className="heading-lg mb-4">Need Housing Support?</h2>
          <p className="body-md mb-8">
            Our Guided and White Glove plans include housing search support and agent introductions.
          </p>
          <a href="/relocation/blueprint" className="btn-primary">View Relocation Plans</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="section-sm border-t border-[#F4ECD8]">
        <div className="container-wide mx-auto text-center">
          <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
          <p className="body-sm">© {new Date().getFullYear()} Mundalo. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default RelocationHousing;
